import { Linkable } from '@/components/blocks/Linkable';
import {
	productBrandAndNameBundleSX,
	productBrandAndNameSX,
	productBrandSx,
	productNameSx,
} from '@/components/blocks/PLPProductCard/styles/productBrandAndName';
import { ProductType } from '@/data/types/Product';
import { getHref_Product } from '@/utils/getHref_Product';
import { mergeSx } from '@/utils/mergeSx';
import { parseHTML } from '@/utils/parseHTMLModern';
import { Typography } from '@mui/material';
import { memo } from 'react';

export const ProductBrandAndName = memo(
	({
		product,
		productHref,
		onClick,
		isBundle,
		isProductList,
	}: {
		productHref: ReturnType<typeof getHref_Product>;
		product: ProductType;
		onClick?: () => void;
		isBundle?: boolean;
		isProductList?: boolean;
	}) => (
		<Typography
			sx={mergeSx(
				productBrandAndNameSX(isProductList),
				isBundle ? productBrandAndNameBundleSX : {}
			)}
			component="p"
			variant="bodyBaseline"
			align="left"
		>
			{!isBundle ? (
				<ProductBrand product={product} productHref={productHref} onClick={onClick} />
			) : null}{' '}
			<ProductName product={product} productHref={productHref} onClick={onClick} />
		</Typography>
	)
);

const ProductBrand = ({
	product,
	productHref,
	onClick,
}: {
	productHref: ReturnType<typeof getHref_Product>;
	product: ProductType;
	onClick?: () => void;
}) => (
	<Linkable
		sx={productBrandSx}
		id={`${product.partNumber}-brand`}
		data-testid={`${product.partNumber}-brand`}
		href={productHref}
		color="textPrimary"
		onClick={onClick}
		className="product-brand"
	>
		{product.manufacturer && parseHTML(product.manufacturer)}
	</Linkable>
);

const ProductName = ({
	product,
	productHref,
	onClick,
}: {
	productHref: ReturnType<typeof getHref_Product>;
	product: ProductType;
	onClick?: () => void;
}) => (
	<Linkable
		id={`${product.partNumber}-name`}
		data-testid={`${product.partNumber}-name`}
		href={productHref}
		color="textPrimary"
		onClick={onClick}
		sx={productNameSx}
		className="product-name"
	>
		{product.name && parseHTML(product.name)}
	</Linkable>
);
